import { render } from "./AccountLogin.vue?vue&type=template&id=3528d3ce"
import script from "./AccountLogin.vue?vue&type=script&lang=js"
export * from "./AccountLogin.vue?vue&type=script&lang=js"
script.render = render

export default script